import React from 'react';
import CustomeEditor from '../../../Core/CkEditor';
import { FormControlLabel, FormHelperText, FormLabel, Grid } from '@material-ui/core';
import { MultipleSelectWithMoreOp, SecondaryButton, SecondaryCheckbox, SelectBox } from '../../../Core/FormInput';

const AddEditCustomerNote = ({
    handleCkeditorstate,
    handleLineChange,
    AutoOcrDocuments,
    handleCheckbox,
    handleLineSubmit,
    state,
    selectedData,
    selectedIndex,
    UpdateLineSubmit
}) => {
    return (
        <>
            <Grid container item spacing={1}>
                <Grid item xs={12} style={{ textAlign: 'left' }}>
                    <CustomeEditor
                        data={state.tCardCustomerNoteDescription}
                        onChange={handleCkeditorstate('tCardCustomerNoteDescription')}
                        placeholder="Add description here"
                        name="tCardCustomerNoteDescription"
                        onReady={(editor) => {
                            editor.focus();
                        }}
                    />
                    <FormHelperText style={{ color: 'red' }}>{state.errors['tCardCustomerNoteDescription']}</FormHelperText>
                </Grid>

                <Grid item xs={12} md={3}>
                    <FormLabel shrink component="legend" className="mandatoryfields">
                        Type
                    </FormLabel>
                    <SelectBox
                        style={{ marginBottom: '4px', marginTop: '8px' }}
                        fullWidth
                        name="tCardCustomerNoteTypeID"
                        value={state.tCardCustomerNoteTypeID}
                        onChange={handleLineChange}
                        List={state.noteTypeList || []}
                    />
                    <FormHelperText style={{ color: 'red' }}>{state.errors['tCardCustomerNoteTypeID']}</FormHelperText>
                </Grid>
                <Grid item xs={12} md>
                    <FormLabel shrink component="legend" className="mandatoryfields">
                        Workflow
                    </FormLabel>

                    <MultipleSelectWithMoreOp options={state.workflowsList} value={selectedData.workflow} onChange={AutoOcrDocuments} />
                    <FormHelperText style={{ color: 'red' }}>{state.errors['workflow']}</FormHelperText>
                </Grid>
                <Grid item xs={12} md={2} sm={6} style={{ marginTop: 20 }}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.tCardCustomerNoteDisplayPopInInternal}
                                onChange={handleCheckbox}
                                name="tCardCustomerNoteDisplayPopInInternal"
                            />
                        }
                        label="Display Internal?"
                    />
                    <FormHelperText style={{ color: 'red' }}>{state.errors['tCardCustomerNoteDisplayPopInInternal']}</FormHelperText>
                </Grid>

                <Grid item xs={12} md={3} sm={6} style={{ marginTop: 20 }}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.tCardCustomerNoteDisplayPopInTechnician}
                                onChange={handleCheckbox}
                                name="tCardCustomerNoteDisplayPopInTechnician"
                            />
                        }
                        label="Display Technician?"
                    />
                    <FormHelperText style={{ color: 'red' }}>{state.errors['tCardCustomerNoteDisplayPopInTechnician']}</FormHelperText>
                </Grid>

                <Grid item xs={12} style={{ margin: '20px 0px', alignItem: 'left' }}>
                    <SecondaryButton fullWidth onClick={selectedIndex != null ? UpdateLineSubmit : handleLineSubmit}>
                        {selectedIndex != null ? 'Update' : 'Add'}
                    </SecondaryButton>
                </Grid>
            </Grid>
        </>
    );
};

export default AddEditCustomerNote;
